/* eslint-disable react/jsx-no-bind */
import React from 'react';
import {ApolloProvider} from 'react-apollo';
import {BrowserRouter, Route} from 'react-router-dom';
import PageContainer from 'containers/PageContainer/PageContainer';

function Root({client, systemData, homeRoute, footerData, redirects}) {
    return (
        <ApolloProvider client={client}>
            <BrowserRouter basename={systemData.basePath}>
                <Route
                    path={`${homeRoute}/:slug*`}
                    render={(props) => (
                        <PageContainer
                            {...props}
                            homeRoute={homeRoute}
                            footerData={footerData}
                            redirects={redirects}
                            systemData={systemData}
                        />
                    )}
                />
            </BrowserRouter>
        </ApolloProvider>
    );
}

export default Root;
